<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options">

  <div class="card-body">
    <form [formGroup]="whiteBoardForm">
      <div class="form-group col-12 whiteboard-row">
        <label for="whiteboardName" class="form-label">Whiteboard Name</label>
        <input type="text" class="form-control" formControlName="whiteboardName" />
        <span class="error-block" *ngIf="!whiteboardName?.valid && whiteboardName?.touched">
          Please provide a Whiteboard Name
        </span>
        <span class="error-block" *ngIf="isNameDuplicated">
          Whiteboard Name must be unique!
        </span>
      </div>
      <div class="form-group col-12 whiteboard-row">
        <label for="whiteboardDescription" class="form-label">Description</label>
        <input type="text" class="form-control" formControlName="whiteboardDescription" />        
      </div>
      <!--<div class="form-group col-12 whiteboard-row" [ngClass]="{'disabled':workspaceSelected}">
        <label for="workspace" class="form-label">Workspace</label>
        <select class="form-control" formControlName="workspace" (change)="selectWorkspace($event)">
          <option *ngFor="let workspace of workspaces" [ngValue]="workspace.id">{{workspace.name}}</option>
        </select>
        <span class="error-block" *ngIf="!workspace?.valid && workspace?.touched">
          Please select Workspace
        </span>
      </div>-->
    </form>

    <div [ngClass]="{'disabled':workspaceSelected}">
      <app-multi-select [title]="userselectTitle"
                       [availableItems]="allUsers"
                       [selectedItems]="selectedUsers"
                       [placeholdertext]="userselectPlaceholdertext"
                       (selectedItemsEvent)="getSelectedItems($event)">
      </app-multi-select>
    </div>
  </div>
</app-modal-wrapper>


